/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import emptyUserImage from "../../assets/images/empty-user-img.png";
import classnames from "classnames"

const ProfileImage = (props) => {
  const {
    data,
  } = props
  
  const [imageUrl, setImageUrl] = useState(emptyUserImage)

  useEffect(() => {
    if (data) {
      let _imageUrl = data.profileImg
      if (!_imageUrl && data.user) {
        _imageUrl = data.user.profileImg
      }
      const img = new Image();
      img.src = _imageUrl;
      img.onload = () => {
        setImageUrl(_imageUrl)
      }
    }
  }, [data])

  return <img
    className={classnames('user-profile-img', {
      'rounded-circle': imageUrl,
    })}
    src={imageUrl || emptyUserImage}
    alt={data ? data.name : 'user'}
  />
}
export default ProfileImage